import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMeldingMobiel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M21.348 4.53 7.393 9.692a.56.56 0 0 0-.331.72l9.325 25.21a.56.56 0 0 0 .72.33l13.956-5.161a.56.56 0 0 0 .33-.72l-9.325-25.21a.56.56 0 0 0-.72-.331"
    />
    <path
      fill="#FDEEF6"
      d="M20.699 6.909 9.444 11.072l7.584 20.503 11.255-4.164z"
    />
    <path
      fill="#F8BADD"
      d="m24.47 30.024-2.85 1.055a1 1 0 1 0 .694 1.876l2.85-1.055a1 1 0 1 0-.693-1.876"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m21 21.13-.75 1.63-1.62-.76L16 23l-3.3-8.88 7.51-2.77 3.28 8.87z"
      clipRule="evenodd"
    />
    <path
      fill="#FDEEF6"
      d="m16.41 14.69 1.35-.5L18.92 18l-.89.33zm2.82 5.55a.72.72 0 0 1-.56 0 .7.7 0 0 1-.37-.4.68.68 0 0 1 0-.56.67.67 0 0 1 .41-.38.726.726 0 0 1 .907.984.73.73 0 0 1-.407.376z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.34 5.36a7.76 7.76 0 1 0 0 15.52 7.76 7.76 0 0 0 0-15.52m-8.76 7.76a8.76 8.76 0 1 1 17.52 0 8.76 8.76 0 0 1-17.52 0"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.34 8.11a5.01 5.01 0 1 0 0 10.02 5.01 5.01 0 0 0 0-10.02m-6.01 5.01a6.01 6.01 0 1 1 12.02 0 6.01 6.01 0 0 1-12.02 0"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.34 10.87a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-3.25 2.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMeldingMobiel);

export default ForwardRef;
